const en = {
  loginTitle: 'Login',
  loginPlaceholderID: 'Identity number',
  loginPlaceholderPassword: 'Password',
  loginPlaceholderEmail: 'Email',
  loginBtn: 'Log-in',
  loginGetPassocdeBtn: 'Get Passcode',
  loginGetPassocde: 'Get a temporary passcode',
  loginGoToLogin: 'Return to login',
  // welcome page
  WelcomeMassage: 'Hello!',
  Welcome1Massage: 'We’re glad to see you',
  //comleted page
  Thankyou: 'Your survey has been successfully submitted.',
  Back: 'Back',
}

export default en
